<template>
  <div class="comp-xl-import-edit">
    <jw-drawer width="100%" :header="false" :footer="false" :visible="data.visible" unmountOnClose>
      <div class="xl-import-edit-page">
        <jw-space direction="vertical">
          <jw-affix :offsetTop="1">
            <jw-card class="import-edit-title-card">
              <div class="import-edit-title-content">
                <span class="edit-title">{{ $t('导入') }}</span>
              </div>
              <jw-space>
                <jw-button type="primary" :loading="data.loading" @click="submit">
                  {{ $t('确定') }}
                </jw-button>
                <jw-button type="outline" @click="handleCancel">
                  {{ $t('取消') }}
                </jw-button>
              </jw-space>
            </jw-card>
          </jw-affix>
          <div class="import-edit-tabs-box">
            <jw-tabs v-model:active-key="data.activeKey" @change="resetParams">
              <jw-tab-pane key="1">
                <template #title> {{ $t('导入新数据') }} </template>
                <jw-space direction="vertical" fill>
                  <jw-typography-title :heading="6" class="typography-title"> 一、{{ $t('准备新数据文件') }} </jw-typography-title>
                  <jw-button type="outline" @click="download" :loading="data.loading">
                    {{ $t('下载数据模板') }}
                  </jw-button>
                  <p class="import-edit-font">{{ $t('注意事项') }}:</p>
                  <p class="import-edit-font">1、{{ $t('若设置后台开启查重后，重复数据将不会新增') }}</p>
                  <p class="import-edit-font">2、{{ $t('模板中的表头字段名称不可更改，表头行不能删除') }}</p>
                  <p class="import-edit-font">3、{{ $t('必填项必须保留') }}</p>
                  <p class="import-edit-font">4、{{ $t('只能上传excel格式文件') }}</p>

                  <jw-typography-title :heading="6" class="typography-title"> 二、{{ $t('上传文件') }} </jw-typography-title>
                  <!--  flow: form.flow,  -->
                  <jw-upload draggable :action="data.urlUpload" :limit="1" ref="uploadRef1" :key="data.urlUpload" @success="onSuccess" :headers="data.headers" @error="onError" accept=".xlsx" @before-upload="beforeUpload" @before-remove="beforeRemove" :auto-upload="false" :data="{ approve: form.approve, isFlowAutoProcess: form.isFlowAutoProcess, entity: form.entity }">
                    <template #upload-button>
                      <div class="lead-in-content">
                        <jw-space direction="vertical" fill>
                          <icon-plus :style="{ color: 'rgb(var(--primary-6))' }" size="32" />
                          <span class="lead-click-font">{{ $t('点击或拖拽文件到此处上传') }}</span>
                          <span :style="{ color: 'var(--color-text-3)', fontSize: '12px' }">{{ $t('tips.onlyImporting') }}</span>
                        </jw-space>
                      </div>
                    </template>
                  </jw-upload>
                  <div>
                    <span class="import-edit-radio-title">{{ $t('是否触发自动化流程') }}:</span>
                    <jw-radio-group v-model="form.isFlowAutoProcess" :default-value="true">
                      <jw-radio :value="true">{{ $t('是') }}</jw-radio>
                      <jw-radio :value="false">{{ $t('否') }}</jw-radio>
                    </jw-radio-group>
                  </div>
                  <div>
                    <span class="import-edit-radio-title">
                      <span>{{ $t('是否触发审批流程') }}: </span>
                      <jw-tooltip>
                        <icon-question-circle size="18" class="import-edit-tooltip-icon" />
                        <template #content>
                          <div>{{ $t('当此对象开启了飞书审批时') }}</div>
                          <div>{{ $t('tips.approveOpenInfo1') }}</div>
                          <div>{{ $t('tips.approveOpenInfo2') }}</div>
                          <div>{{ $t('tips.approveOpenInfo3') }}</div>
                        </template>
                      </jw-tooltip>
                    </span>

                    <jw-radio-group v-model="form.approve" :default-value="0">
                      <jw-radio :value="1">{{ $t('直接发起审批') }}</jw-radio>
                      <jw-radio :value="0">{{ $t('无需发起审批') }}</jw-radio>
                      <jw-radio :value="2">{{ $t('仅保存，完善后发起审批') }}</jw-radio>
                    </jw-radio-group>
                  </div>
                </jw-space>
              </jw-tab-pane>
              <jw-tab-pane key="2">
                <template #title> {{ $t('更新现有数据') }} </template>
                <jw-space direction="vertical" fill>
                  <jw-typography-title :heading="6" class="typography-title"> 一、{{ $t('准备更新数据文件') }} </jw-typography-title>
                  <!--<jw-button type="outline" @click="download">-->
                  <!--   {{ $t('下载数据模板') }}-->
                  <!--</jw-button>-->
                  <p class="import-edit-font">{{ $t('注意事项') }}:</p>
                  <p class="import-edit-font">1、{{ $t('可从列表页导出含有【唯一ID】字段的数据，【唯一ID】字段将作为匹配原数据的唯一标识，请勿随意修改或删除') }}</p>
                  <p class="import-edit-font">2、{{ $t('文件中必须有【唯一ID】字段，名称不一致或不存在时会导入失败') }}</p>
                  <p class="import-edit-font">3、{{ $t('必填字段若为空，将不会更新该字段') }}</p>
                  <p class="import-edit-font">4、{{ $t('有些特殊字段不会执行更新，包括有: 自增编码、引用字段、计算字段、附件，等每个对象下赋有特殊逻辑的字段') }}</p>
                  <p class="import-edit-font">5、{{ $t('只能上传excel格式文件') }}</p>

                  <jw-typography-title :heading="6" class="typography-title"> 二、{{ $t('上传文件') }} </jw-typography-title>
                  <jw-upload draggable :action="data.urlUpdate" :limit="1" ref="uploadRef2" :key="data.urlUpdate" @success="onSuccess" :headers="data.headers" @error="onError" accept=".xlsx" @before-upload="beforeUpload" @before-remove="beforeRemove" :auto-upload="false" :data="{ empty: form.empty, isFlowAutoProcess: form.isFlowAutoProcess, entity: form.entity }">
                    <template #upload-button>
                      <div class="lead-in-content">
                        <jw-space direction="vertical" fill>
                          <icon-plus :style="{ color: 'rgb(var(--primary-6))' }" size="32" />
                          <span class="lead-click-font">{{ $t('点击或拖拽文件到此处上传') }}</span>
                          <span :style="{ color: 'var(--color-text-3)', fontSize: '12px' }">{{ $t('tips.onlyImporting') }}</span>
                        </jw-space>
                      </div>
                    </template>
                  </jw-upload>
                  <div v-for="(item, i) in importEditRadio" :key="data.urlUpdate + i">
                    <span class="import-edit-radio-title">{{ item.label }}:</span>
                    <jw-radio-group v-model="form[item.params]" :default-value="true">
                      <jw-radio :value="true">{{ $t('是') }}</jw-radio>
                      <jw-radio :value="false">{{ $t('否') }}</jw-radio>
                    </jw-radio-group>
                  </div>
                </jw-space>
              </jw-tab-pane>
            </jw-tabs>
          </div>
        </jw-space>
      </div>
    </jw-drawer>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { getToken, clearToken } from '@/utils/auth';
import { Message } from '@arco-design/web-vue';
import { publicService, setService } from '@/api/';
import { tools } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import router from '@/router';
const token = getToken() || null;
const uploadRef1 = ref();
const uploadRef2 = ref();
const data = reactive({
  activeKey: '1',
  urlUpload: '/api/entity/upload/upload/template', // 新接口（根据模板导入）
  urlUpdate: '/api/entity/upload/upload/update', // 导入并更新接口
  type: 'TEMPLATE',
  file1: undefined,
  file2: undefined,
  visible: false,
  loading: false,
  onUp: undefined,
  headers: {
    authorization: `Bearer ${token}`
  }
});
const form = reactive({
  isFlowAutoProcess: false,
  approve: 0,
  empty: false,
  entity: ''
});
const importEditRadio = ref([
  {
    label: t('字段未填写时是否更新为空值'),
    params: 'empty'
  },
  {
    label: t('是否触发自动化流程'),
    params: 'isFlowAutoProcess'
  }
  // {
  //   label: t('是否触发审批流程'),
  //   params: 'approve'
  // }
]);
const uploadMessage1 = ref('');
const uploadMessage2 = ref('');
const emit = defineEmits(['cb']);
const open = async (record) => {
  form.entity = record.entity;
  data.activeKey = '1';
  data.file1 = undefined;
  data.file2 = undefined;
  resetParams();
  await getDownloadProgress();
  if (data.status) {
    await getTemplate(); //获取模板信息
    data.visible = true;
  } else {
    Message.warning(t('tips.uploadMessage'));
  }
};

// 切换重置参数
const resetParams = () => {
  form.isFlowAutoProcess = false;
  form.approve = 0;
  form.empty = false;
};
// 获取当前进度接口
const getDownloadProgress = async () => {
  try {
    const params = {
      type: data.type,
      entity: form.entity
    };
    const res = await publicService.getDownloadProgress(params);
    console.log('状态', res.result);
    data.status = res.result;
  } catch (e) {
    Message.error(e.message || e.statusText || t('获取当前进度失败'));
  }
};

//获取模板列表
const getTemplate = async () => {
  const params = {
    entityId: form.entity
  };
  try {
    const json = await setService.getUploadTemplateList(params);
    if (json.error) {
      Message.error(json.error?.msg || t('操作失败'));
      return false;
    }
    data.excelTitle = json.result[0]?.template || '导入模板'; //模板的名称
  } catch (e) {
    console.log(e);
  }
};
// 上传成功的回调
const onSuccess = (fileItem) => {
  console.log('文件上传成功', fileItem);
  const logoutCode = [10006, 10007, 10008];
  if (fileItem.response?.code !== 0) {
    //导出【确定】报错
    if (logoutCode.indexOf(fileItem.response?.code) > -1) {
      clearToken();
      router.replace({
        name: 'login',
        query: { back: router.currentRoute.fullPath }
      });
    } else {
      fileItem.status = 'error';
      if (data.activeKey === '1') {
        uploadMessage1.value = fileItem.response?.msg || t('导入出错');
        Message.error(uploadMessage1.value);
      } else {
        uploadMessage2.value = fileItem.response?.msg || t('导入出错');
        Message.error(uploadMessage2.value);
      }
    }
    data.loading = false;
    return;
  }
  if (fileItem.status === 'done') {
    if (data.onUp === '1') {
      Message.success(t('tips.importNewFile'));
    } else {
      Message.success(t('tips.importUpdataFile'));
    }
    // Message.success(t('tips.uploadAlert'));
    emit('cb');
  }
  data.loading = false;
  handleCancel();
};
// 上传失败的回调
const onError = (fileItem) => {
  console.log('文件上传失败', fileItem);
  data.loading = false;
  if (fileItem.status === 'error') {
    if (data.activeKey === '1') {
      uploadMessage1.value = t('上传失败');
    } else {
      uploadMessage2.value = t('上传失败');
    }
    Message.error(t('上传失败'));
  }
};
// 上传前效验文件大小
const beforeUpload = (file) => {
  if (data.activeKey === '1') {
    uploadMessage1.value = '';
    data.file1 = file;
  } else {
    uploadMessage2.value = '';
    data.file2 = file;
  }
  const fileTypeArray = file.name.split('.');
  const fileType = fileTypeArray.length > 0 && fileTypeArray[fileTypeArray.length - 1]; // 文件类型
  console.log('文件类型', fileType);
  if (fileType !== 'xlsx') {
    Message.error(t('上传文件格式不正确'));
    return false;
  }
  if (file.size / 1024 / 1024 < 20) {
    return true;
  } else {
    Message.error(t('tips.uploadFailedIsLarge'));
    return false;
  }
};
const beforeRemove = () => {
  if (data.activeKey === '1') {
    data.file1 = null;
    uploadMessage1.value = '';
  } else {
    data.file2 = null;
    uploadMessage2.value = '';
  }
  return true;
};

// 模板下载
const download = () => {
  // 在此调用模板下载接口
  getLeadInTemplate();
};

// 模板下载接口
const getLeadInTemplate = async () => {
  // handleCancel();
  data.loading = true;
  try {
    const res = await publicService.getLeadInTemplate({ entity: form.entity });
    // 获取模板
    tools.downLoad(res, data.excelTitle);
    data.status = res.result;
  } catch (e) {
    console.log('模板下载出错', e);
    Message.error(t('模板下载出错'));
  }
  data.loading = false;
};
// 点击取消
const handleCancel = () => {
  data.visible = false;
};
const submit = (e) => {
  console.log('提交表单', data.file1, data.file2, uploadMessage1, uploadMessage2);
  if (data.activeKey === '1') {
    if (!data.file1) {
      return Message.error(t('请选择文件'));
    }
    if (uploadMessage1.value) {
      return Message.error(uploadMessage1.value);
    }
  } else {
    if (!data.file2) {
      return Message.error(t('请选择文件'));
    }
    if (uploadMessage2.value) {
      return Message.error(uploadMessage2.value);
    }
  }

  data.loading = true;
  data.onUp = data.activeKey;
  e.stopPropagation();
  if (data.activeKey === '1') {
    console.log('第一个提交');
    uploadRef1.value.submit();
  } else {
    console.log('第二个提交');
    uploadRef2.value.submit();
  }
  handleCancel;
};
defineExpose({
  open
});
</script>
<style scoped lang="less">
@import './xl-import-edit.less';
</style>
